import axios, { AxiosResponse, AxiosError, AxiosRequestConfig } from 'axios';

export function mergeUrlWithParams(url = '', payload) {
  const urlParams = [];
  const matches = [...url.matchAll(/{(\w+)}/g)];
  for (let i = 0; i < matches.length; i++) {
    const match = matches[i];
    urlParams.push(match[1]);
  }
  let mergedUrl = url;
  for (const param of urlParams) {
    mergedUrl = mergedUrl.replace(`{${param}}`, payload[param]);
  }
  return mergedUrl;
}

//     ____ ____  _   _ ____
//    / ___|  _ \| | | |  _ \
//   | |   | |_) | | | | | | |
//   | |___|  _ <| |_| | |_| |
//    \____|_| \_\\___/|____/
//

/**
 * @param {String} url
 * @param {Object} urlParams
 * @param {Object} params
 * @param {any} data
 * @param {AxiosRequestConfig} axiosConfig
 * @return Promise<AxiosResponse>
 * @throws AxiosError
 * */
export function serviceCreate(
  url,
  { urlParams = {}, params = {}, data = undefined, axiosConfig = {} } = {}
) {
  const mergedUrl = mergeUrlWithParams(url, urlParams);
  return axios.post(mergedUrl, data, {
    params,
    ...axiosConfig
  });
}

/**
 * @param {String} url
 * @param {Object} urlParams
 * @param {Object} params
 * @param {AxiosRequestConfig} axiosConfig
 * @return Promise<AxiosResponse>
 * @throws AxiosError
 * */
export function serviceRetrieve(
  url,
  { urlParams = {}, params = {}, axiosConfig = {} } = {}
) {
  const mergedUrl = mergeUrlWithParams(url, urlParams);
  return axios.get(mergedUrl, { params });
}

/**
 * @param {String} url
 * @param {Object} urlParams
 * @param {Object} params
 * @param {any} data
 * @param {boolean} partial
 * @param {AxiosRequestConfig} axiosConfig
 * @return Promise<AxiosResponse>
 * @throws AxiosError
 * */
export function serviceUpdate(
  url,
  {
    urlParams = {},
    params = {},
    data = undefined,
    partial = false,
    axiosConfig = {}
  } = {}
) {
  const mergedUrl = mergeUrlWithParams(url, urlParams);
  return axios[partial ? 'patch' : 'put'](mergedUrl, data, {
    params,
    ...axiosConfig
  });
}

/**
 * @param {String} url
 * @param {Object} urlParams
 * @param {Object} params
 * @param {any} data
 * @param {AxiosRequestConfig} axiosConfig
 * @return Promise<AxiosResponse>
 * @throws AxiosError
 * */
export function serviceDelete(
  url,
  { urlParams = {}, params = {}, axiosConfig = {} } = {}
) {
  const mergedUrl = mergeUrlWithParams(url, urlParams);
  return axios.delete(mergedUrl, {
    params,
    ...axiosConfig
  });
}

export default {
  create: serviceCreate,
  retrieve: serviceRetrieve,
  update: serviceUpdate,
  delete: serviceDelete
};
